import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { supplyOrderDetail } from "../../../redux/actions/orderActions";
import { useDispatch } from "react-redux";
import LoadingSpinnerTable from "../../utilites/loader";
import CurrentOrdersViewTable from "../../tables/currentOrdersViewTable";
import SuppliedFromCfaPdfView from "./suppliedFromCfaPdfView";

const SuppliedFromCfaViewModal = ({ ordersViewShow, showClose, id }) => {
  const dispatch = useDispatch();
  const [orderDetailData, setOrderDetailData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfView, setPdfView] = useState(false);

  useEffect(() => {
    console.log(ordersViewShow);
    if (ordersViewShow == true) {
      dispatch(supplyOrderDetail(id, onSuccess, onError));
      setLoading(true);
    }
  }, [ordersViewShow]);

  const onSuccess = (data) => {
    setLoading(false);
    setOrderDetailData(data.data.data);
    let newData = data.data.data.orderProducts.map((ex) => ({
      "Product Name": ex.product?.product_name,
      Division: ex?.vendorDivision?.name,
      Qnatity: ex?.quantity,
      "Free Quantity": ex?.offer,
      Price: ex?.price,
    }));
    console.log(newData);
    // setCSVData(newData);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const data = [
    {
      title: "Order ID",
      content: orderDetailData?.order?.order_id
        ? orderDetailData?.order?.order_id
        : "--",
    },
    {
      title: "Company Name",
      content: orderDetailData?.vendor?.name
        ? orderDetailData?.vendor?.name
        : "--",
    },
    {
      title: "Division",
      content: orderDetailData?.vendorDivision?.name
        ? orderDetailData?.vendorDivision?.name
        : "--",
    },
    {
      title: "Value Of Order",
      content: orderDetailData?.ordered_value
        ? `₹ ${orderDetailData?.ordered_value}`
        : "--",
    },
    {
      title: "Order Status",
      content: orderDetailData?.status ? orderDetailData?.status : "--",
    },
    {
      title: "Doctor Name",
      content: orderDetailData?.order?.doctor?.name
        ? orderDetailData?.order?.doctor?.name
        : "--",
    },
    {
      title: "Pharmacy Name",
      content: orderDetailData?.order?.pharmacy_id
        ? orderDetailData?.order?.pharmacy?.pharmacy_name
        : orderDetailData?.order?.doctor?.pharmacy_type == "attach"
          ? orderDetailData?.order?.doctor?.doctorAttachPharmacy?.pharmacy
              ?.pharmacy_name
          : orderDetailData?.order?.doctor?.pharmacy_type == "self"
            ? orderDetailData?.order?.doctor?.doctorSelfPharmacy?.pharmacy_name
            : orderDetailData?.order?.doctor?.pharmacy_type == "dispensing" &&
              "Dispensing",
    },
    {
      title: "Mobile Number",
      content:
        orderDetailData?.order?.doctor?.mobile ??
        orderDetailData?.order?.pharmacy?.mobile,
    },
  ];

  const data2 = [
    {
      title: "Alternate Mobile Number",
      content:
        orderDetailData?.order?.doctor?.alternate_mobile ??
        orderDetailData?.order?.pharmacy?.alternate_mobile,
    },
    {
      title: "Email Address",
      content:
        orderDetailData?.order?.doctor?.email ??
        orderDetailData?.order?.pharmacy?.email,
    },
    {
      title: "Address",
      content:
        [
          orderDetailData?.order?.doctor?.address?.address_one ??
            orderDetailData?.order?.pharmacy?.address?.address_one,
          orderDetailData?.order?.doctor?.address?.address_two ??
            orderDetailData?.order?.pharmacy?.address?.address_two,
          orderDetailData?.order?.doctor?.address?.address_three ??
            orderDetailData?.order?.pharmacy?.address?.address_three,
        ]
          .filter((val) => val !== undefined && val !== null && val !== "")
          .join(", ") || "--",
    },
    {
      title: "Landmark",
      content:
        orderDetailData?.order?.doctor?.address?.landmark ??
        orderDetailData?.order?.pharmacy?.address?.landmark,
    },
    {
      title: "Concerned FF Name",
      content: orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.name
        ? orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.name
        : "--",
    },
    {
      title: "Concerned FF Mobile Number",
      content: orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.mobile
        ? orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.mobile
        : "--",
    },
    {
      title: "Concerned CFA Name",
      content: orderDetailData?.order?.cfa?.cfa_name
        ? orderDetailData?.order?.cfa?.cfa_name
        : "--",
    },
    {
      title: "Concerned CFA Mobile Number",
      content: orderDetailData?.order?.cfa?.mobile
        ? orderDetailData?.order?.cfa?.mobile
        : "--",
    },
  ];

  return (
    <>
      <Modal
        centered
        show={ordersViewShow}
        onHide={showClose}
        id={id}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderDetailData?.order?.order_id}- View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              <div className="mt-1">
                <button
                  type="button"
                  onClick={() => {
                    showClose();
                    setPdfView(true);
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_12"
                >
                  print
                </button>
              </div>
              <button
                className="modal-close-btn px-3 py-1 fs_12 "
                onClick={() => showClose()}
              >
                <span className="fw_700">close</span>
              </button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="w-100 h-100" id="toRender">
          {loading == true ? (
            <LoadingSpinnerTable />
          ) : (
            <div className="w-100 h-100">
              <div className="mx-2">
                <div className="d-flex ">
                  <div className="col-6 col-lg-5">
                    {data.map((items, index) => (
                      <div className="d-flex" key={index}>
                        {items?.title != "Order Status" ? (
                          <>
                            <div className="col-6 col-sm-4">
                              <span className="color_747f9e fs_14">
                                {items?.title}
                              </span>
                            </div>
                            <span className="fs_14 ms-3 col-6 mt-1">
                              {items?.content}
                            </span>
                          </>
                        ) : (
                          <>
                            <div className="col-6 col-sm-4">
                              <span className={`color_747f9e fs_14`}>
                                {items?.title}
                              </span>
                            </div>
                            <span
                              className={`fs_14 ms-3 col-6 mt-1 ${
                                orderStatus.find(
                                  (e) => e?.status == items?.content,
                                )?.color
                              }`}
                            >
                              {
                                orderStatus.find(
                                  (e) => e?.status == items?.content,
                                )?.value
                              }
                            </span>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="col-6">
                    {data2.map((items, index) => (
                      <div className="d-flex gap-" key={index}>
                        <div className="col-6 col-sm-5">
                          <span className="color_747f9e fs_14">
                            {items.title}
                          </span>
                        </div>
                        <span className="fs_14 ms-3 col-6">
                          {items.content}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-3">
                  <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text">
                    Order Details - {orderDetailData?.order?.order_id}
                  </p>
                  <div className="mt-3">
                    <CurrentOrdersViewTable
                      orderProducts={orderDetailData?.order?.orderProducts}
                      total={orderDetailData?.order?.total}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
      <SuppliedFromCfaPdfView
        orderDetailData={orderDetailData}
        id={id}
        show={pdfView}
        handleClose={() => setPdfView(false)}
      />
    </>
  );
};

export default SuppliedFromCfaViewModal;

export const orderStatus = [
  { status: "pending", value: "Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
